import { isMobile } from './is-mobile';

const MAX_HEIGHT = 1080;
const MAX_WIDTH = 1920;

interface ResizeContentParams {
  target: HTMLElement;
  maxWidth?: number;
  maxHeight?: number;
  returnScaleValue?: boolean;
}

export const resizeContent = ({ target, maxWidth = MAX_WIDTH, maxHeight = MAX_HEIGHT, returnScaleValue = false }: ResizeContentParams) => {
  let scale;
  let wWidth;
  let wHeight;

  wWidth = window.innerWidth;
  wHeight = window.innerHeight;
  const widthToHeight = maxWidth / maxHeight;
  const wWidthToHeight = wWidth / wHeight;

  if (wWidthToHeight > widthToHeight) {
    wWidth = wHeight * widthToHeight;
    scale = wWidth / maxWidth;
  } else {
    wHeight = wWidth / widthToHeight;
    scale = wHeight / maxHeight;
  }

  if (returnScaleValue) {
    return scale;
  }
  if (target) {
      // @ts-ignore | Property 'zoom' does not exist on type 'CSSStyleDeclaration'.
      target.style.zoom = `${scale}`;
  }
};

export const addResizeListener = () => {
  if (isMobile()) return;
  const target = document.querySelector('#root') as HTMLElement;
  if (!target) return;
  resizeContent({ target });
  window.addEventListener('resize', () => resizeContent({ target }));
};
